import { BaseSystemModel, Guid, RecursivePartial } from '@models/base';

export enum VzTagOptions {
    HideIcon         = 1,
    HideText         = 2,
    HideIconParent   = 4,
    HideTextParent   = 8,
    HideTagParent    = 16,
}

export interface IVzTagTpl {
    orgId: Guid;
    text: string;
    icon?: string;
    color?: string;
    parentId?: Guid;
}

export class VzTag extends BaseSystemModel {
    _type = BaseSystemModel.Type.Tag;

    orgId!: Guid;
    text?: string;
    icon?: string;
    color?: string;
    parentId?: Guid;
    projectId?: Guid;
    uniqueGroup?: boolean;
    description?: string;
    options: number = 0;
    parents?: VzTag[];

    _label?: string;
    _path: string = '';

    constructor(json?: RecursivePartial<VzTag>) {
        super(json);
        this.parseVzTag(json || {});
    }

    parse(json: RecursivePartial<VzTag>): VzTag {
        super.parse(json);
        this.parseVzTag(json);
        return this;
    }

    private parseVzTag(json: RecursivePartial<VzTag>): void {
        VzTag.assignFields<VzTag>(this, json, [
            'orgId',
            'text',
            'icon',
            'color',
            'parentId',
            'projectId',
            'uniqueGroup',
            'description',
            'options',
            '_label',
            '_path'
        ]);
        VzTag.assignClassArrays<VzTag>(this, json, { parents: VzTag });
        if (!this.icon && !this.parentId) {
            this.icon = 'vzi-tag-lines';
        }
        if (!this._label) {
            this._label = this.text + (this.description ? ' (' + this.description + ')' : '');
        }
        if (!this._path) {
            this._path = (this.text || '') + (this.parents ?  '/' + this.parents.map(x => x.text || '').join('/') : '');
        }
    }
}
